import React from 'react';
import { useLocation } from 'react-router-dom';
import './ModeIndicator.css';

interface ModeIndicatorProps {
  className?: string;
}

type RouteMode = 'demo' | 'real';

const ModeIndicator: React.FC<ModeIndicatorProps> = ({ className = '' }) => {
  const location = useLocation();

  const getCurrentMode = (): RouteMode => {
    if (location.pathname === '/demo') {
      return 'demo';
    }
    return 'real';
  };

  const currentMode = getCurrentMode();

  const getModeColor = (mode: RouteMode): string => {
    switch (mode) {
      case 'real':
        return '#f59e0b'; // Orange
      case 'demo':
        return '#3b82f6'; // Blue
      default:
        return '#6b7280'; // Gray
    }
  };

  const getModeDescription = (mode: RouteMode): string => {
    switch (mode) {
      case 'real':
        return 'Using real ML endpoint';
      case 'demo':
        return 'Using client-side simulation (no server needed)';
      default:
        return 'Unknown mode';
    }
  };

  return (
    <div className={`mode-indicator ${className}`} data-testid="mode-indicator">
      <div
        className="mode-dot"
        style={{ backgroundColor: getModeColor(currentMode) }}
        data-testid="mode-dot"
      ></div>
      <div className="mode-info">
        <span className="mode-name" data-testid="mode-name">
          {currentMode.toUpperCase()} MODE
        </span>
        <span className="mode-description" data-testid="mode-description">
          {getModeDescription(currentMode)}
        </span>
      </div>
    </div>
  );
};

export default ModeIndicator;
